import { useEffect } from 'react'
import { useLocation, useNavigate, Link } from "react-router";
import $ from 'jquery'
import { SignOutButton } from './signOutButton'
import * as bootstrap from 'bootstrap'
import { useAppSelector } from '../hooks/reduxToolkit'
import { selectEarliestTodo, selectTodoCount } from '../reduxToolkit/selectors/todos'
import { useSession } from '../providers/supabase';
import differenceInDays from 'date-fns/differenceInDays'
import { parseDateInTimeZone } from '../../lib/formatDateInTimeZone'
import { Tooltip } from './tooltip'
import { selectUnreadNotificationCount } from '../reduxToolkit/selectors/selectUnreadNotificationCount'
import { present } from '../../lib/util/present'
import { useFeature, usePlaidLinkEnabled } from '../providers/featureFlags'
import { useTerminology } from '../hooks/useTerminology'

import './topNav.scss'

export function TopNav() {

  return <>
    <MobileTopBar />
    <nav className="top-nav navbar navbar-expand-lg">
      <DesktopNav />

      <MobileNav/>

    </nav>
    <MobileOffcanvas />
  </>
}

function useIsTeamOwner() {
  const userId = useAppSelector(s => s.membership.userId)
  const organization = useAppSelector(s => s.membership.organization)
  return organization && organization.created_by_user_id === userId
    ? organization
    : null
}

function DesktopNav() {
  const currentRoute = useLocation().pathname
  const teamOrg = useIsTeamOwner()
  const terms = useTerminology()
  const plaidEnabled = usePlaidLinkEnabled()
  const aliceEnabled = useFeature('alice_ai')

  return <div className="container-fluid d-none d-md-flex nav-desktop">
    <div className='navbar-brand'>
      <h2>HealthShare</h2>
    </div>

    <div className={'nav-item' + (currentRoute === '/' ? ' active' : '')}>
      <Link to='/' className='nav-link'>
        <i className='material-icons-outlined'>home</i>
        <span className='d-none d-md-inline'>Home</span>
      </Link>
    </div>

    <div className={'nav-item' + (currentRoute === '/expenses' ? ' active' : '')}>
      <Link to='/expenses' className='nav-link'>
        <i className='material-icons-outlined'>payments</i>
        <span className='d-none d-md-inline'>Expenses</span>
      </Link>
    </div>

    <div className={'nav-item' + (currentRoute === '/incidents' ? ' active' : '')}>
      <Link to='/incidents' className='nav-link'>
        <i className='material-icons-outlined'>sticky_note_2</i>
        <span className='d-none d-md-inline'>{terms.Incidents}</span>
      </Link>
    </div>

    <div className={'nav-item' + (currentRoute === '/receipts' ? ' active' : '')}>
      <Link to='/receipts' className='nav-link'>
        <i className='material-icons-outlined'>receipt</i>
        <span className='d-none d-md-inline'>Attachments</span>
      </Link>
    </div>

    <TodoListNavItem />

    <NotificationsNavItem />

    {aliceEnabled && (
      <div className={'nav-item' + (currentRoute.startsWith('/alice') ? ' active' : '')}>
        <Link to='/alice' className='nav-link'>
          <i className='material-icons-outlined'>support_agent</i>
          <span className='d-none d-md-inline'>Alice</span>
        </Link>
      </div>
    )}

    <div className='nav-item dropdown'>
      <button className="nav-link dropdown-toggle btn btn-link nav-desktop__more-button" data-bs-toggle="dropdown" aria-expanded="false">
        More
      </button>
      <ul className="dropdown-menu">
        <li><Link to="/profile" className='dropdown-item'>Profile</Link></li>
        <li><Link to="/dependents" className='dropdown-item'>Dependents</Link></li>
        <li><Link to="/providers" className='dropdown-item'>Providers</Link></li>
        <li><Link to="/settings" className='dropdown-item'>Settings</Link></li>
        <li><Link to="/subscription" className='dropdown-item'>Subscription</Link></li>
        {teamOrg && (
          <li><a href={`/admin/organizations/${teamOrg.id}/users`} className='dropdown-item'>Manage Team</a></li>
        )}
        {plaidEnabled && (
          <li><Link to="/connectedAccounts" className='dropdown-item'>Connected Accounts</Link></li>
        )}
        <li><a href="/admin" className='dropdown-item'>Plan Administrator</a></li>
        <li><Link to="/deleteAccount" className='dropdown-item'>Delete Account</Link></li>
      </ul>
    </div>

    <div className='nav-item mt-auto'>
      <SignOutButton className='nav-link'>
        <i className='material-icons'>logout</i>
        Sign Out
      </SignOutButton>
    </div>
    <div className={'nav-item' + (currentRoute === '/help' ? ' active' : '')}>
      <Link to="help" className='nav-link'>
        <i className="material-icons d-none d-md-inline-block">help</i>
        <span className='d-none d-md-inline'>Help</span>
      </Link>
    </div>
  </div>
}

function MobileNav() {
  const currentRoute = useLocation().pathname
  const plaidEnabled = usePlaidLinkEnabled()

  useEffect(() => {
    const hideOffcanvasOnClick = (e: JQuery.ClickEvent) => {
      const offcanvasDiv = $(e.target).closest('.offcanvas')[0]
      const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasDiv)
      console.log('click', offcanvasDiv, offcanvas)
      offcanvas?.hide()
    }
    $(document).on('click', '.offcanvas .nav-link', hideOffcanvasOnClick)

    return () => {
      $(document).off('click', hideOffcanvasOnClick)
    }
  }, [])


  return <div className="container-fluid d-flex d-md-none nav-mobile">
    <div className={'nav-item' + (currentRoute === '/' ? ' active' : '')}>
      <Link to='/' className='nav-link'>
        <i className='material-icons-outlined'>home</i>
      </Link>
    </div>

    <div className={'nav-item' + (currentRoute === '/incidents' ? ' active' : '')}>
      <Link to='/incidents' className='nav-link'>
        <i className='material-icons-outlined'>sticky_note_2</i>
      </Link>
    </div>

    <div className={'nav-item' + (currentRoute === '/receipts' ? ' active' : '')}>
      <Link to='/receipts' className='nav-link'>
        <i className='material-icons-outlined'>receipt</i>
      </Link>
    </div>

    {plaidEnabled && <ExpensesNavItem />}

    <TodoListNavItem />

    <a className="nav-link" data-bs-toggle="offcanvas" href="#offcanvasMobileNav" role="button" aria-controls="offcanvasMobileNav">
      <i className='material-icons-outlined'>menu</i>
    </a>
  </div>
}

function MobileOffcanvas() {
  const currentRoute = useLocation().pathname

  const session = useSession()
  const userIsHealthshareDev = session?.user?.email?.endsWith('@healthsharetech.com')

  const unassociatedExpenseCount = useAppSelector((s) => s.expenses.expenses.filter((e) => !present(e.incident_id)).length);
  const aliceEnabled = useFeature('alice_ai')
  const teamOrg = useIsTeamOwner()
  const plaidEnabled = usePlaidLinkEnabled()

  return <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasMobileNav" aria-labelledby="offcanvasMobileNavLabel">
  <div className="offcanvas-header">
    <h2>HealthShare</h2>
    <a className='btn btn-link text-reset' href="#offcanvasMobileNav" data-bs-dismiss="offcanvas" aria-label="Close">
      <i className='material-icons-outlined'>close</i>
    </a>
  </div>
  <div className="offcanvas-body">
    <NotificationsNavItem />

    {aliceEnabled && (
      <div className={'nav-item nav-item__alice' + (currentRoute.startsWith('/alice') ? ' active' : '')}>
        <Link to="/alice" className='nav-link'>
          <i className='material-icons-outlined'>support_agent</i>
          <span className='d-inline'>Alice</span>
        </Link>
      </div>
    )}

    {!plaidEnabled && (
      <div className={'nav-item nav-item__expenses' + (currentRoute === '/expenses' ? ' active' : '')}>
        <Link to="/expenses" className='nav-link'>
          <span className="nav-item__expenses-button">
            <div className="nav-item__expenses-button-wrapper">
              <i className='material-icons-outlined'>payments</i>
              {unassociatedExpenseCount > 0 && <span className="notification-badge">{unassociatedExpenseCount}</span>}
            </div>
          </span>
          <span className='d-inline'>Expenses</span>
        </Link>
      </div>
    )}
    
    <div className={'nav-item' + (currentRoute === '/profile' ? ' active' : '')}>
      <Link to="/profile" className='nav-link'>Profile</Link>
    </div>
    
    <div className={'nav-item' + (currentRoute === '/dependents' ? ' active' : '')}>
      <Link to="/dependents" className='nav-link'>Dependents</Link>
    </div>

    <div className={'nav-item' + (currentRoute === '/providers' ? ' active' : '')}>
      <Link to="/providers" className='nav-link'>Providers</Link>
    </div>
    
    <div className={'nav-item' + (currentRoute === '/settings' ? ' active' : '')}>
      <Link to="/settings" className='nav-link'>Settings</Link>
    </div>
    <div className={'nav-item' + (currentRoute === '/subscription' ? ' active' : '')}>
      <Link to="/subscription" className='nav-link'>Subscription</Link>
    </div>
    {teamOrg && (
      <div className='nav-item'>
        <a href={`/admin/organizations/${teamOrg.id}/users`} className='nav-link'>
          <i className='material-icons-outlined'>groups</i>
          <span className='d-inline'>Manage Team</span>
        </a>
      </div>
    )}
    {plaidEnabled && (
      <div className={'nav-item' + (currentRoute === '/connectedAccounts' ? ' active' : '')}>
        <Link to="/connectedAccounts" className='nav-link'>Connected Accounts</Link>
      </div>
    )}

    <div className={'nav-item' + (currentRoute === '/deleteAccount' ? ' active' : '')}>
      <Link to="/deleteAccount" className='nav-link'>Delete Account</Link>
    </div>
    
    {(import.meta.env.DEV || import.meta.env.VITE_ENV == 'staging' || userIsHealthshareDev) && (
      <div className={'nav-item' + (currentRoute === '/test' ? ' active' : '')}>
        <Link to='/test' className='nav-link'>
          <i className='material-icons-outlined'>settings</i>
        </Link>
      </div>
    )}

    <div className='nav-item mt-auto'>
      <SignOutButton className='nav-link'>
        <i className='material-icons'>logout</i>
        Sign Out
      </SignOutButton>
    </div>
    <div className={'nav-item' + (currentRoute === '/help' ? ' active' : '')}>
      <Link to="help" className='nav-link'>
        <i className="material-icons">help</i>
        Help
      </Link>
    </div>
  </div>
</div>
}

function ExpensesNavItem() {
  const currentRoute = useLocation().pathname
  const plaidLoaded = useAppSelector((s) => s.plaid.loaded)
  const hasConnectedAccounts = useAppSelector((s) => s.plaid.items.length > 0)
  const unassignedExpenseCount = useAppSelector((s) =>
    s.expenses.expenses.filter((e) => !present(e.incident_id) && !e.deleted_at).length
  )

  const to = (plaidLoaded && !hasConnectedAccounts) ? '/connectedAccounts' : '/expenses'
  const isActive = currentRoute === to

  return <div className={'nav-item nav-item__expenses' + (isActive ? ' active' : '')}>
    <Link to={to} className='nav-link'>
      <span className="nav-item__expenses-button">
        <div className="nav-item__expenses-button-wrapper">
          <i className='material-icons-outlined'>payments</i>
          {hasConnectedAccounts && unassignedExpenseCount > 0 && (
            <span className="notification-badge">{unassignedExpenseCount}</span>
          )}
        </div>
      </span>
      <span className='d-none d-md-inline'>Expenses</span>
    </Link>
  </div>
}

function TodoListNavItem() {
  const currentRoute = useLocation().pathname
  
  const todoCount = useAppSelector(selectTodoCount())
  const earliestTodo = useAppSelector(selectEarliestTodo())
  
  let tooltip: string | undefined = undefined
  let dueSoon = false
  if (earliestTodo?.has_due_date) {
    const firstTodoDueDate = earliestTodo?.due_date
    const dayDiff = firstTodoDueDate && differenceInDays(parseDateInTimeZone(firstTodoDueDate), new Date())
    dueSoon = typeof(dayDiff) == 'number' && dayDiff <= 14

    tooltip = typeof(dayDiff) == 'number' &&
      dayDiff > 0 ?
        `Next to-do due in ${dayDiff} days` :
        `You have something due today!`
  }

  return <div className={`nav-item nav-item__todo-list ${currentRoute === '/todos' ? 'active' : ''}`}>
    <Link to='/todos' className='nav-link'>
      <span className="nav-item__todo-list-button">
        <div className="nav-item__todo-list-button-wrapper">
          <i className='material-icons-outlined'>checklist</i>
          {todoCount > 0 && (
            dueSoon ? 
              <Tooltip tooltip={tooltip}>
                <span className="notification-badge warning">
                  <i className="material-icons">warning</i>
                </span>
              </Tooltip> :
              <span className="notification-badge">{todoCount}</span>
          )}
        </div>
      </span>
      <span className='d-none d-md-inline'>Checklist</span>
    </Link>
  </div>
}

function NotificationsNavItem() {
  const currentRoute = useLocation().pathname

  const unreadCount = useAppSelector(selectUnreadNotificationCount);
  
  return <div className={`nav-item nav-item__notifications ${currentRoute === '/notifications' ? 'active' : ''}`}>
    <Link to='/notifications' className='nav-link'>
      <span 
        className="nav-item__notifications-button"
      >
        <div className="nav-item__notifications-button-wrapper">
          <i className='material-icons-outlined'>mail</i>
          {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
        </div>
      </span>
      <span className='d-inline'>Notifications</span>
    </Link>
  </div>
}

function MobileTopBar() {
  let navigate = useNavigate();
  const location = useLocation();
  const unreadCount = useAppSelector(selectUnreadNotificationCount);
  
  // We can only go back if we're not at a root route
  const canGoBack = ![ '/', '/expenses', '/incidents', '/receipts', '/todos' ].includes(location.pathname)
  
  return <div className="d-flex mobile-top-bar d-md-none">
    <button className={`btn btn-link mobile-top-bar__back-button ${canGoBack ? '' : 'd-none'}`} onClick={() => navigate(-1)}>
      <i className='material-icons-outlined'>arrow_back</i>
    </button>
    
    {unreadCount > 0 && location.pathname !== '/notifications' && (
      <button 
        className="btn btn-link mobile-top-bar__notifications-button" 
        onClick={() => navigate('/notifications')}
      >
        <div className="mobile-top-bar__notifications-button-wrapper">
          <i className='material-icons-outlined'>mail</i>
          <span className="notification-badge">{unreadCount}</span>
        </div>
      </button>
    )}
  </div>
}
